module.exports = __webpack_public_path__ + "static/media/pharma-epass-logo.fc660052.png";